import { Link } from "react-router";
import { useLanguage } from "../../i18n/LanguageContext";
import { translations } from "../../i18n/translations";

export function Footer() {
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <footer
      className="w-full pt-12 pb-8 px-6"
      style={{ borderTop: "1px solid var(--border)" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-3 mb-8">
          <span
            className="text-2xl tracking-widest uppercase"
            style={{
              fontFamily: "var(--font-display)",
              color: "var(--gold)",
              letterSpacing: "0.22em",
              fontStyle: "italic",
            }}
          >
            Assistly
          </span>
          <p
            className="text-sm"
            style={{
              color: "var(--foreground-muted)",
              fontFamily: "var(--font-body)",
            }}
          >
            {t.tagline}
          </p>
        </div>

        <div
          className="h-px mb-8"
          style={{
            background:
              "linear-gradient(90deg, transparent, var(--border-strong), transparent)",
          }}
        />

        <div className="flex items-center justify-center gap-6 text-xs">
          <Link
            to="/legal"
            style={{ color: "var(--foreground-muted)", fontFamily: "var(--font-body)", transition: "color 0.2s" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--foreground-muted)")}
          >
            {t.privacyPolicy}
          </Link>
          <span style={{ color: "var(--border-strong)" }}>·</span>
          <Link
            to="/rules"
            style={{ color: "var(--foreground-muted)", fontFamily: "var(--font-body)", transition: "color 0.2s" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--foreground-muted)")}
          >
            {t.terms}
          </Link>
        </div>

        <p
          className="text-center text-xs mt-6"
          style={{ color: "var(--foreground-faint)", fontFamily: "var(--font-body)" }}
        >
          {t.copyright}
        </p>
      </div>
    </footer>
  );
}
